import { useQuery, gql } from "@apollo/client";

import { MAD_FRAGMENT } from "./useGetMad";

export const GET_USER = gql`
  query getUser($id: ID!) {
    user(id: $id) {
      id
      name
      avatar
      email
      notes
      locale
      role
      canInsert
      documents {
        id
        url
        filename
      }
      createdAt
      company {
        id
        name
      }
      madsAsTalent {
        ...MadFragment
      }
      madsAsReferent {
        ...MadFragment
      }
    }
  }
  ${MAD_FRAGMENT}
`;

export default (options) => {
  return useQuery(GET_USER, options);
};
